/* @flow */
import Config from 'Config';
import apiRequest from 'lib/apiRequest';
import cookies from 'lib/Cookies';
import { transform, checkIgnore, initConsoleError } from 'utils/setupErrorLogging';
import { rollbarSnippet } from 'utils/rollbarSnippet';

const NORMAL_TOKEN = '37c613c5a8b34fba89cd4fcfebc76808';
const VIP_TOKEN = '910516711b6a4745b1040625ac214251';

function decodeTelemetryToken(token) {
  return JSON.parse(Buffer.from(token, 'base64').toString());
}

export async function promiseTelemetry(): Promise<any> {
  if (__TEST__) {
    return;
  }

  let rollbarToken = NORMAL_TOKEN;
  try {
    const response = await apiRequest('/telemetry', 'GET', {});
    // The response has a set-cookie header but it only worked for v2 endpoints but not graphql endpoints
    // Manually setting the cookie with the right domain here fixed it
    cookies.set('r101_telemetry', response.telemetry, {
      domain: Config.Environment.API_PROXY_COOKIE_DOMAIN,
    });
    const payload = decodeTelemetryToken(response.telemetry);
    rollbarToken = payload.use_vip_rollbar ? VIP_TOKEN : NORMAL_TOKEN;
  } catch (err) {
    // just keep using the normal rollbar token
  }

  // Initialize rollbar
  rollbarSnippet({
    accessToken: rollbarToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    reportLevel: 'error',
    transform,
    checkIgnore,
    payload: {
      environment: Config.Environment.ROLLBAR_ENVIRONMENT,
      release: [Config.Environment.VERSION_PREFIX, Config.Environment.EMPIRE_RELEASE].join('-'),
      client: {
        javascript: {
          source_map_enabled: true,
          guess_uncaught_frames: true,
        },
      },
    },
    maxItems: 10,
  });

  // Setup console errors to log to rollbar
  initConsoleError();
}
